<template>
    <el-select :style="{width:width}" v-on="$listeners" v-bind="$attrs" :value="value" @change="(val)=>{$emit('input',val)}">
        <el-option v-for="(item,index) in selectList" :key="item.value+index" :label="item.label" :value="item.value"></el-option>
    </el-select>
</template>

<script>
export default {
    name: 'CSelect',
    inheritAttrs: false,
    props: {
        value: {
            required: false
        },
        // 宽度
        width: {
            type: String
        },
        // 数据字典的key值
        lookup: {
            type: String
        },
        // 也可以直接给一个处理好的数组
        options: {
            type: Array,
            default: () => []
        }

    },
    data() {
        return {
            selectList: []
        }
    },
    mounted() {
        if (this.lookup) {
            this.selectList = this.findLookupList(this.lookup)
        }
        if (this.options) {
            this.selectList = this.options
        }
    },
    watch: {
        'options.length'() {
            this.selectList = this.options
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/global/CSelect.vue